import { render } from "./NutritionTracker.vue?vue&type=template&id=a1e6066c&scoped=true"
import script from "./NutritionTracker.vue?vue&type=script&lang=js"
export * from "./NutritionTracker.vue?vue&type=script&lang=js"

import "./NutritionTracker.vue?vue&type=style&index=0&id=a1e6066c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1e6066c"]])

export default __exports__